import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../components/fragment/modal/ReuseModal";
import RootState from "../../../redux/type";
import { deleteAdminUserInvite } from "../../../redux/users";

interface myComponentProps {
  onClose?: () => void;
  onFinish?: () => void;
  visible?: boolean;
  details?: any;
}

const DeactivateUserModal = ({
  onClose,
  visible,
  details,
  onFinish,
}: myComponentProps) => {
  const { loading_users } = useSelector((state: RootState) => state.users);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const obj = {
      id: details?.id,
    };
    const data = await dispatch(deleteAdminUserInvite(obj) as any);

    if (data?.payload?.data?.status) {
      onFinish && onFinish();
    }
  };
  return (
    <>
      <ReuseModal
        hideCancel={loading_users}
        onBtnClick={handleSubmit}
        visible={visible}
        onClose={onClose}
        loading={loading_users}
        deleteType
        btnLabel={`Delete Team Member`}
        title={`Delete Team Member   ( ${details?.first_name} )`}
        deleteText="Are you sure you want to delete this user’s profile. "
      />
    </>
  );
};

export default DeactivateUserModal;
